import Phaser from 'phaser';
import { COLORS, FONTS, toHexColor } from '../config/gameConfig';
import { TEACH_PANELS } from '../content/teach-panels';
import type { EventBus, Term } from '../systems/EventBus';

/** Small inline link rendered next to a modal's title prompt. Click → opens
 *  the Layer-1 teach panel for the given term. Pull-not-push education:
 *  shown only if the player wants the explanation. */
export const renderHelpLink = (
  scene: Phaser.Scene,
  container: Phaser.GameObjects.Container,
  rightEdgeX: number,
  topY: number,
  term: Term,
  bus: EventBus,
): Phaser.GameObjects.Text => {
  const label = `What is ${TEACH_PANELS[term].title}? ↗`;
  const baseColor = toHexColor(COLORS.markedTermUnderline);
  const hoverColor = '#9bbfff';

  const text = scene.add.text(rightEdgeX, topY, label, {
    fontFamily: FONTS.ui,
    fontSize: '12px',
    color: baseColor,
    fontStyle: 'italic',
  }).setOrigin(1, 0).setInteractive({ useHandCursor: true });

  text.on('pointerover', () => text.setColor(hoverColor));
  text.on('pointerout', () => text.setColor(baseColor));
  text.on('pointerdown', () => bus.emit('teach:requested', { term }));

  container.add(text);
  return text;
};
